<div class="d-flex flex-grow-1 flex-column">
  <div class="modal-header pt-1 mb-3">
    <h2 class="modal-title" id="modal-basic-title" translate>Diploma download</h2>
    <button class="btn-close btn-red" (click)="dismiss()"></button>
  </div>
  <div class="d-flex flex-grow-1 flex-column justify-content-center">
    <div class="modal-body" translate>
      <div class="d-flex flex-column align-items-center justify-content-center">
        @if(afterIOS()) {
        <circular-check-icon class="my-4"></circular-check-icon>
        <h3 class="mb-3 text-center" translate>
          Your diploma has been downloaded and you can find it under files -> IKO folder
        </h3>
        <small class="text-center" translate
          >You can close this windows now or it will be closed automatically in 5 seconds.</small
        >
        } @else if (this.generatingDiploma()){
        <h3 class="mb-3 text-center" translate>We are generating your diploma, please wait...</h3>
        <circular-spinner iconClass="icon-32" class="mb-3"></circular-spinner>
        }@else {
        <h3 class="text-center" translate>Your diploma is ready for downloading!</h3>
        }
        <div id="diploma-container" class="diploma-container">
          <div class="diploma-info">
            <h3 class="diploma-user-name">
              <span class="me-1" [innerHTML]="currentUser?.field_first_name"></span>
              <span [innerHTML]="currentUser?.field_surname"></span>
            </h3>
            <div class="diploma-user-id">{{ currentUser?.uid }}</div>
            <h1 class="diploma-qualification" [innerHTML]="cert?.training_level"></h1>
            <div class="diploma-cert-date">{{ cert?.certification_date }}</div>
            <div class="diploma-cert-expiration">{{ expires }}</div>
          </div>
          <img class="diploma-img" src="/assets/images/diploma/diploma.jpg" />
        </div>
      </div>
    </div>
  </div>
</div>
